import { useState, useEffect, useCallback } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const testimonials = [
  {
    quote: 'O AURA transformou completamente a minha relação com o meu corpo. As aulas de yoga com a Ana são uma experiência única de autodescoberta e paz interior.',
    name: 'Joana Ferreira',
    role: 'Designer · Aluna há 2 anos',
    img: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&q=80',
  },
  {
    quote: 'As sessões de meditação com o Rui mudaram a forma como lido com o stress do dia-a-dia. Sinto-me mais centrado, mais presente e muito mais feliz.',
    name: 'Tomás Ribeiro',
    role: 'Advogado · Aluno há 3 anos',
    img: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&q=80',
  },
  {
    quote: 'As massagens da Sofia são simplesmente mágicas. Cada sessão é uma viagem de profundo relaxamento. O espaço AURA é um refúgio de serenidade em Lisboa.',
    name: 'Inês Carvalho',
    role: 'Médica · Aluna há 1 ano',
    img: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&q=80',
  },
  {
    quote: 'A consultoria nutricional do Pedro complementou perfeitamente o meu treino de yoga. Nunca me senti tão energizada e em harmonia com o meu corpo.',
    name: 'Margarida Sousa',
    role: 'Arquitecta · Aluna há 18 meses',
    img: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=200&q=80',
  },
];

export default function Testimonials() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  const goTo = useCallback((idx) => {
    if (animating) return;
    setAnimating(true);
    setTimeout(() => {
      setCurrent(idx);
      setAnimating(false);
    }, 300);
  }, [animating]);

  const next = () => goTo((current + 1) % testimonials.length);
  const prev = () => goTo((current - 1 + testimonials.length) % testimonials.length);

  useEffect(() => {
    const t = setInterval(next, 6000);
    return () => clearInterval(t);
  });

  const t = testimonials[current];

  return (
    <section className="py-28 bg-beige-light/30">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16 reveal">
          <p className="font-dm text-xs tracking-[0.4em] text-sage uppercase mb-4">O que dizem</p>
          <h2 className="font-playfair italic text-5xl font-light text-ink">Testemunhos</h2>
          <div className="w-12 h-px bg-sage mx-auto mt-6" />
        </div>

        <div className="reveal">
          <div className="relative bg-white/70 rounded-3xl p-10 md:p-14 border border-beige/40 shadow-sm overflow-hidden">
            {/* Large quote mark */}
            <div className="absolute top-6 left-8 font-playfair text-[120px] leading-none text-sage/15 select-none pointer-events-none">
              "
            </div>

            <div
              className={`transition-all duration-300 ${animating ? 'opacity-0 translate-x-4' : 'opacity-100 translate-x-0'}`}
            >
              {/* Quote */}
              <p className="font-playfair italic text-xl md:text-2xl text-ink/80 leading-relaxed text-center relative z-10 mb-10">
                "{t.quote}"
              </p>

              {/* Author */}
              <div className="flex flex-col items-center gap-3">
                <img
                  src={t.img}
                  alt={t.name}
                  className="w-14 h-14 rounded-full object-cover border-2 border-sage/30"
                />
                <div className="text-center">
                  <p className="font-playfair font-medium text-ink">{t.name}</p>
                  <p className="font-dm text-xs text-ink-light tracking-wide mt-0.5">{t.role}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Controls */}
          <div className="flex items-center justify-center gap-6 mt-8">
            <button
              onClick={prev}
              className="w-10 h-10 rounded-full border border-beige flex items-center justify-center hover:border-sage hover:text-sage transition-all duration-200 cursor-pointer text-ink-light"
              aria-label="Anterior"
            >
              <ChevronLeft size={18} />
            </button>

            <div className="flex gap-2">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => goTo(i)}
                  className={`rounded-full transition-all duration-300 cursor-pointer ${
                    i === current ? 'w-6 h-2 bg-sage' : 'w-2 h-2 bg-beige hover:bg-sage/50'
                  }`}
                  aria-label={`Testemunho ${i + 1}`}
                />
              ))}
            </div>

            <button
              onClick={next}
              className="w-10 h-10 rounded-full border border-beige flex items-center justify-center hover:border-sage hover:text-sage transition-all duration-200 cursor-pointer text-ink-light"
              aria-label="Próximo"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
